import { PollData_Design_PollDesign_Background_Type } from './../ricos-schema/next-schema';
import { getScaleImageSrc } from './../wix-rich-content-common/lib/imageUtils';
import { unreachable } from './../editor-common';

export function getRandomValue<T>(pool: T[]) {
  return pool[Math.floor(Math.random() * pool.length)];
}

export function toBackgroundString(
  background: { type: string; image: $TSFixMe; gradient: $TSFixMe; color: $TSFixMe },
  backgroundType: PollData_Design_PollDesign_Background_Type,
  width: number,
  height: number
): string | null {
  switch (backgroundType) {
    case PollData_Design_PollDesign_Background_Type.GRADIENT:
      try {
        const { gradient } = background;
        return `linear-gradient(${gradient.angle}deg, ${gradient.startColor}, ${gradient.lastColor})`;
      } catch (error) {
        console.error(error);
        return null;
      }
    case PollData_Design_PollDesign_Background_Type.IMAGE:
      if (!width || !height) {
        return null;
      }
      // eslint-disable-next-line no-case-declarations
      const URL = background.image?.src?.url;
      // eslint-disable-next-line no-case-declarations
      const imageSrc = getScaleImageSrc(URL, width, height);
      return `url('${imageSrc}') center / cover`;
    case PollData_Design_PollDesign_Background_Type.COLOR:
      return background.color;
    default:
      unreachable(backgroundType);
      return background.color;
  }
}
